import { cn } from "@project/ui";

/**
 * Isotipo HomeExpense (asset estático optimizado del pack app).
 */
export function BrandMark({ className }: { className?: string }): JSX.Element {
  return (
    <img
      src="/icon1.png"
      alt=""
      decoding="async"
      className={cn("shrink-0 object-contain", className)}
      aria-hidden
    />
  );
}
